export default {
  colorMain: '#247ba0',
  colorMainDarker: '#70c1b3',
  colorMainLighter: '#b2dbbf',
  colorSecondary: '#f3ffbd',
  colorTertiary: '#ff1654',
  colorQuaternary: '#777777'
}
